import {Entity} from '../core/entity/core.base.entity';
import {Column} from '../core/entity/core.entity.column';
import {JoinColumn} from '../core/entity/core.entity.join.column';
import {EntityTable} from '../core/entity/core.entity.table.decorator';
import {Transient} from '../core/entity/core.entity.transient';
import {EnvironmentKind} from '../enum/environment.kind';
import {FieldRelationKind} from '../enum/field.relation.kind';
import {FieldTypeKind} from '../enum/field.type.kind';
import {AssetGroupEntity} from './asset.group.entity';
import {LayerEntity} from './layer.entity';
import {LayoutEntity} from './layout.entity';

@EntityTable('layout_asset_group_xref', 'aa3d0eaf-afe3-4705-b992-1bb873a00951')
export class LayoutAssetGroupXrefEntity extends Entity {

    @JoinColumn(FieldTypeKind.GUID, LayoutEntity, false, false, FieldRelationKind.BELONGS_TO, 'layout', 'aliasId', 'layoutId')
    public layoutId: string;

    @JoinColumn(FieldTypeKind.GUID, AssetGroupEntity, false, false, FieldRelationKind.BELONGS_TO, 'assetGroup', 'aliasId', 'assetGroupId')
    public assetGroupId: string;

    @Column(FieldTypeKind.GUID, false, false, true)
    public aliasId: string;

    @Column(FieldTypeKind.ENUM, false)
    public environmentKind: EnvironmentKind;

    @Column(FieldTypeKind.LONG)
    public index: number;

    @Transient()
    public layer: LayerEntity;

}
